var _path, _rect, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 212,
    viewBox: "0 0 343 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 7.58172 7.58172 4 12 4H331C335.418 4 339 7.58172 339 12V200C339 204.418 335.418 208 331 208H12C7.58172 208 4 204.418 4 200V12Z",
    fill: "#EBE4F7",
    stroke: "#976AD1",
    strokeWidth: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 47,
    width: 100,
    height: 118,
    rx: 4,
    fill: "#EBE4F7",
    stroke: "#976AD1",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 90,
    r: 24,
    fill: "white",
    stroke: "#976AD1",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144 165H44C44.0126 137.936 65.9562 116 93.0233 116H94.9767C122.044 116 143.987 137.936 144 165Z",
    fill: "white",
    stroke: "#976AD1",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179 58C179 56.8954 179.895 56 181 56H253C254.105 56 255 56.8954 255 58V66C255 67.1046 254.105 68 253 68H181C179.895 68 179 67.1046 179 66V58ZM179 82C179 80.8954 179.895 80 181 80H301C302.105 80 303 80.8954 303 82V90C303 91.1046 302.105 92 301 92H181C179.895 92 179 91.1046 179 90V82ZM181 120C179.895 120 179 120.895 179 122V130C179 131.105 179.895 132 181 132H213C214.105 132 215 131.105 215 130V122C215 120.895 214.105 120 213 120H181ZM181 144C179.895 144 179 144.895 179 146V154C179 155.105 179.895 156 181 156H301C302.105 156 303 155.105 303 154V146C303 144.895 302.105 144 301 144H181ZM227 122C227 120.895 227.895 120 229 120H261C262.105 120 263 120.895 263 122V130C263 131.105 262.105 132 261 132H229C227.895 132 227 131.105 227 130V122Z",
    fill: "#976AD1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFront);
export default __webpack_public_path__ + "static/media/cardFront.1237ee7082a501bfa1e57da5201b291d.svg";
export { ForwardRef as ReactComponent };